/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_BackInputs */

const en_statement_taxonomy_editor_back = /** @type {(inputs: Statement_Taxonomy_Editor_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to classification templates`)
};

const nl_statement_taxonomy_editor_back = /** @type {(inputs: Statement_Taxonomy_Editor_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar classificatiesjablonen`)
};

/**
* | output |
* | --- |
* | "Back to classification templates" |
*
* @param {Statement_Taxonomy_Editor_BackInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_back = /** @type {((inputs?: Statement_Taxonomy_Editor_BackInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_BackInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_back(inputs)
	return en_statement_taxonomy_editor_back(inputs)
});